import React from "react";
import { SidebarIcons } from "../../StandardContentSidebar/SidebarIcons";



const requestmenus = [
  {
    id: 9,
    label: "Request",
    uri: "request",
    type: "collapsible",
    icon: SidebarIcons.RequestIcon,
    color: "#4B4B4B",
    children: [
      {
        id: 19,
        uri: `licence/list-licence`,
        label: "Additional License",
        type: "nav-item",
        icon: SidebarIcons.AdditionalLicenseIcon,
        color: "#4B4B4B",
      },
      {
        id: 20,
        uri: `storage/list-storage`,
        label: "Additional Storage",
        type: "nav-item",
        icon: SidebarIcons.AdditionalStorageIcon,
        color: "#4B4B4B",
      },
      {
        id: 21,
        uri: `purchase/list-purchase`,
        label: "Addon Purchase",
        type: "nav-item",
        icon: SidebarIcons.AddonPurchaseIcon,
        color: "#4B4B4B",
      },
      {
        id: 22,
        uri: `plan/cancel-plan`,
        label: "Cancel Plan",
        type: "nav-item",
        icon: SidebarIcons.CancelPlanIcon,
        color: "#4B4B4B",
      },
      {
        id: 23,
        uri: `renewal/list-renewal`,
        label: "Renewal",
        type: "nav-item",
        icon: SidebarIcons.RenewalIcon,
        color: "#4B4B4B",
      },

    ],
  },
];
export default requestmenus;
